import bwipjs from "bwip-js";
import { Buffer } from 'buffer';
import {FormattedMessage} from 'react-intl';
import http_data from "../../DataService/http-data";
import Utils from '../Common/Utils.js';

import {injectIntl} from 'react-intl';

const convertSF36 = (dataToExport, intl) => {
    let data = JSON.parse(dataToExport)
    const averages = [
      [<FormattedMessage id="sf36.form.average.physical_function" defaultMessage="The most severe nausea?"/>],
      [<FormattedMessage id="sf36.form.average.physical_limitation" defaultMessage="Sleep disorders?"/>],
      [<FormattedMessage id="sf36.form.average.emotional_limitation" defaultMessage="The most severe nausea?"/>],
      [<FormattedMessage id="sf36.form.average.energy" defaultMessage="Sleep disorders?"/>],
      [<FormattedMessage id="sf36.form.average.well_being" defaultMessage="The most severe nausea?"/>],
      [<FormattedMessage id="sf36.form.average.social" defaultMessage="The most severe nausea?"/>],
      [<FormattedMessage id="sf36.form.average.pain" defaultMessage="The most severe nausea?"/>],
      [<FormattedMessage id="sf36.form.average.general" defaultMessage="The most severe nausea?"/>],
    ]
    let columns_data = [
        [intl.formatMessage({id:"sf36.form.one_title"})],
        [intl.formatMessage({id:"sf36.form.two_title"})],
        [intl.formatMessage({id:"sf36.form.three_title"})],
        [intl.formatMessage({id:"sf36.form.three.one_title"})],
        [intl.formatMessage({id:"sf36.form.three.two_title"})],
        [intl.formatMessage({id:"sf36.form.three.three_title"})],
        [intl.formatMessage({id:"sf36.form.three.four_title"})],
        [intl.formatMessage({id:"sf36.form.three.five_title"})],
        [intl.formatMessage({id:"sf36.form.three.six_title"})],
        [intl.formatMessage({id:"sf36.form.three.seven_title"})],
        [intl.formatMessage({id:"sf36.form.three.eight_title"})],
        [intl.formatMessage({id:"sf36.form.three.nine_title"})],
        [intl.formatMessage({id:"sf36.form.three.ten_title"})],
        [intl.formatMessage({id:"sf36.form.four_title"})],
        [intl.formatMessage({id:"sf36.form.four.one_title"})],
        [intl.formatMessage({id:"sf36.form.four.two_title"})],
        [intl.formatMessage({id:"sf36.form.four.three_title"})],
        [intl.formatMessage({id:"sf36.form.four.four_title"})],
        [intl.formatMessage({id:"sf36.form.five_title"})],
        [intl.formatMessage({id:"sf36.form.five.one_title"})],
        [intl.formatMessage({id:"sf36.form.five.two_title"})],
        [intl.formatMessage({id:"sf36.form.five.three_title"})],
        [intl.formatMessage({id:"sf36.form.six_title"})],
        [intl.formatMessage({id:"sf36.form.seven_title"})],
        [intl.formatMessage({id:"sf36.form.eight_title"})],
        [intl.formatMessage({id:"sf36.form.nine_title"})],
        [intl.formatMessage({id:"sf36.form.nine.one_title"})],
        [intl.formatMessage({id:"sf36.form.nine.two_title"})],
        [intl.formatMessage({id:"sf36.form.nine.three_title"})],
        [intl.formatMessage({id:"sf36.form.nine.four_title"})],
        [intl.formatMessage({id:"sf36.form.nine.five_title"})],
        [intl.formatMessage({id:"sf36.form.nine.six_title"})],
        [intl.formatMessage({id:"sf36.form.nine.seven_title"})],
        [intl.formatMessage({id:"sf36.form.nine.eight_title"})],
        [intl.formatMessage({id:"sf36.form.nine.nine_title"})],
        [intl.formatMessage({id:"sf36.form.ten_title"})],
        [intl.formatMessage({id:"sf36.form.eleven_title"})],
        [intl.formatMessage({id:"sf36.form.eleven.one_title"})],
        [intl.formatMessage({id:"sf36.form.eleven.two_title"})],
        [intl.formatMessage({id:"sf36.form.eleven.three_title"})],
        [intl.formatMessage({id:"sf36.form.eleven.four_title"})],
        [intl.formatMessage({id:"form.registered_by"})],        
    ]
    const optionsQuestionOne = [
      <FormattedMessage id="sf36.form.option.one.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.one.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.one.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.one.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.one.five" defaultMessage="The most severe nausea?"/>,
    ]
    const optionsQuestionTwo = [
      <FormattedMessage id="sf36.form.option.two.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.two.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.two.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.two.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.two.five" defaultMessage="The most severe nausea?"/>,
    ]
    const optionsQuestionThree = [
      <FormattedMessage id="sf36.form.option.three.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.three.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.three.three" defaultMessage="The most severe nausea?"/>,
    ]
    const optionsQuestionFour = [
      <FormattedMessage id="sf36.form.option.four.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.four.two" defaultMessage="Sleep disorders?"/>,
    ]
    const optionsQuestionSix = [
      <FormattedMessage id="sf36.form.option.six.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.six.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.six.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.six.four" defaultMessage="Sleep disorders?"/>,
    ]
    const optionsQuestionEight = [
      <FormattedMessage id="sf36.form.option.eight.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.eight.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eight.three" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eight.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eight.five" defaultMessage="Sleep disorders?"/>,
    ]
    const optionsQuestionNine = [
      <FormattedMessage id="sf36.form.option.nine.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.nine.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.nine.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.nine.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.nine.five" defaultMessage="The most severe nausea?"/>,
    ]
    const optionsQuestionEleven = [
      <FormattedMessage id="sf36.form.option.eleven.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.eleven.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eleven.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.eleven.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eleven.five" defaultMessage="The most severe nausea?"/>,
    ]
    const values = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    data.forEach(parsed_data => {
        switch (parsed_data.label) {
            case "one":
                columns_data[0].push(intl.formatMessage({id: optionsQuestionOne[parsed_data.value].props.id}))
                values[0] = parsed_data.value
                break
            case "two":
                columns_data[1].push(intl.formatMessage({id: optionsQuestionTwo[parsed_data.value].props.id}))
                values[1] = parsed_data.value
                break
            case "three_one":
                columns_data[3].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[2] = parsed_data.value
                break
            case "three_two":
                columns_data[4].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[3] = parsed_data.value
                break
            case "three_three":
                columns_data[5].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[4] = parsed_data.value
                break
            case "three_four":
                columns_data[6].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[5] = parsed_data.value
                break
            case "three_five":
                columns_data[7].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[6] = parsed_data.value
                break
            case "three_six":
                columns_data[8].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[7] = parsed_data.value
                break
            case "three_seven":
                columns_data[9].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[8] = parsed_data.value
                break
            case "three_eight":
                columns_data[10].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[9] = parsed_data.value
                break
            case "three_nine":
                columns_data[11].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[10] = parsed_data.value
                break
            case "three_ten":
                columns_data[12].push(intl.formatMessage({id: optionsQuestionThree[parsed_data.value].props.id}))
                values[11] = parsed_data.value
                break
            case "four_one":
                columns_data[14].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[12] = parsed_data.value
                break
            case "four_two":
                columns_data[15].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[13] = parsed_data.value
                break
            case "four_three":
                columns_data[16].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[14] = parsed_data.value
                break
            case "four_four":
                columns_data[17].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[15] = parsed_data.value
                break
            case "five_one":
                columns_data[19].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[16] = parsed_data.value
                break
            case "five_two":
                columns_data[20].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[17] = parsed_data.value
                break
            case "five_three":
                columns_data[21].push(intl.formatMessage({id: optionsQuestionFour[parsed_data.value].props.id}))
                values[18] = parsed_data.value
                break
            case "six":
                columns_data[22].push(intl.formatMessage({id: optionsQuestionSix[parsed_data.value].props.id}))
                values[19] = parsed_data.value
                break
            case "seven":
                columns_data[23].push(intl.formatMessage({id: optionsQuestionSix[parsed_data.value].props.id}))
                values[20] = parsed_data.value
                break
            case "eight":
                columns_data[24].push(intl.formatMessage({id: optionsQuestionEight[parsed_data.value].props.id}))
                values[21] = parsed_data.value
                break
            case "nine_one":
                columns_data[26].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[22] = parsed_data.value
                break
            case "nine_two":
                columns_data[27].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[23] = parsed_data.value
                break
            case "nine_three":
                columns_data[28].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[24] = parsed_data.value
                break
            case "nine_four":
                columns_data[29].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[25] = parsed_data.value
                break
            case "nine_five":
                columns_data[30].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[26] = parsed_data.value
                break
            case "nine_six":
                columns_data[31].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[27] = parsed_data.value
                break
            case "nine_seven":
                columns_data[32].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[28] = parsed_data.value
                break
            case "nine_eight":
                columns_data[33].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[29] = parsed_data.value
                break
            case "nine_nine":
                columns_data[34].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[30] = parsed_data.value
                break
            case "ten":
                columns_data[35].push(intl.formatMessage({id: optionsQuestionNine[parsed_data.value].props.id}))
                values[31] = parsed_data.value
                break
            case "eleven_one":
                columns_data[37].push(intl.formatMessage({id: optionsQuestionEleven[parsed_data.value].props.id}))
                values[32] = parsed_data.value
                break
            case "eleven_two":
                columns_data[38].push(intl.formatMessage({id: optionsQuestionEleven[parsed_data.value].props.id}))
                values[33] = parsed_data.value
                break
            case "eleven_three":
                columns_data[39].push(intl.formatMessage({id: optionsQuestionEleven[parsed_data.value].props.id}))
                values[34] = parsed_data.value
                break
            case "eleven_four":
                columns_data[40].push(intl.formatMessage({id: optionsQuestionEleven[parsed_data.value].props.id}))
                values[35] = parsed_data.value
                break
            case "registered_by": 
               columns_data[41].push(parsed_data.value)
                break
        }
    })
    let num_values = values
    values.forEach((value, index) => {
        let converted_values
        switch(index + 1) {
            case 1:
            case 2:
            case 22:
            case 23:
            case 24:
            case 26:
            case 27:
            case 30:
            case 34:
            case 36:
                converted_values = [100,75,50,25,0]
                break
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
                converted_values = [0,50,100]
                break
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
                converted_values = [0,100]
                break
            case 20:
            case 21:
                converted_values = [100,66,33,0]
                break
            case 25:
            case 28:
            case 29:
            case 31:
            case 32:
            case 33:
            case 35:
                converted_values = [0,25,50,75,100]
                break
        }
        num_values[index] = converted_values[value]
    })
    averages[0].push(Utils.makeAverage(num_values, [2,3,4,5,6,7,8,9,10,11]))
    averages[1].push(Utils.makeAverage(num_values, [12,13,14,15]))
    averages[2].push(Utils.makeAverage(num_values, [16,17,18]))
    averages[3].push(Utils.makeAverage(num_values, [22,26,28,30]))
    averages[4].push(Utils.makeAverage(num_values, [23,24,25,27,29]))
    averages[5].push(Utils.makeAverage(num_values, [19,31]))
    averages[6].push(Utils.makeAverage(num_values, [20,21]))
    averages[7].push(Utils.makeAverage(num_values, [0,32,33,34,35]))
    let final = ""
    columns_data.forEach(data => {
        if (data[1] !== undefined) {
            final += data[0] + " " + data[1] + " \n"
        }
        else {
            final += data[0] + " \n"
        }
    })
    return final;
}

const convertMDASI = (dataToExport, intl) => {
    let data = JSON.parse(dataToExport)
    let columns_data = [
        [intl.formatMessage({id:"mdasi.form.severity.title_simple"})],
        [intl.formatMessage({id:"mdasi.form.severity.one"})],
        [intl.formatMessage({id:"mdasi.form.severity.two"})],
        [intl.formatMessage({id:"mdasi.form.severity.three"})],
        [intl.formatMessage({id:"mdasi.form.severity.four"})],
        [intl.formatMessage({id:"mdasi.form.severity.five"})],
        [intl.formatMessage({id:"mdasi.form.severity.six"})],
        [intl.formatMessage({id:"mdasi.form.severity.seven"})],
        [intl.formatMessage({id:"mdasi.form.severity.eight"})],
        [intl.formatMessage({id:"mdasi.form.severity.nine"})],
        [intl.formatMessage({id:"mdasi.form.severity.ten"})],
        [intl.formatMessage({id:"mdasi.form.severity.eleven"})],
        [intl.formatMessage({id:"mdasi.form.severity.twelve"})],
        [intl.formatMessage({id:"mdasi.form.severity.thirteen"})],
        [intl.formatMessage({id:"mdasi.form.impact.title_simple"})],
        [intl.formatMessage({id:"mdasi.form.impact.one"})],
        [intl.formatMessage({id:"mdasi.form.impact.two"})],
        [intl.formatMessage({id:"mdasi.form.impact.three"})],
        [intl.formatMessage({id:"mdasi.form.impact.four"})],
        [intl.formatMessage({id:"mdasi.form.impact.five"})],
        [intl.formatMessage({id:"mdasi.form.impact.six"})],
        [intl.formatMessage({id:"form.registered_by"})],                
    ]

    data.forEach(data_details => {
        switch (data_details.label) {
            case "severity_one":
                columns_data[1].push(data_details.value)
                break
            case "severity_two":
                columns_data[2].push(data_details.value)
                break
            case "severity_three":
                columns_data[3].push(data_details.value)
                break
            case "severity_four":
                columns_data[4].push(data_details.value)
                break
            case "severity_five":
                columns_data[5].push(data_details.value)
                break
            case "severity_six":
                columns_data[6].push(data_details.value)
                break
            case "severity_seven":
                columns_data[7].push(data_details.value)
                break
            case "severity_height":
                columns_data[8].push(data_details.value)
                break
            case "severity_nine":
                columns_data[9].push(data_details.value)
                break
            case "severity_ten":
                columns_data[10].push(data_details.value)
                break
            case "severity_eleven":
                columns_data[11].push(data_details.value)
                break
            case "severity_twelve":
                columns_data[12].push(data_details.value)
                break
            case "severity_thirteen":
                columns_data[13].push(data_details.value)
                break
            case "impact_one":
                columns_data[15].push(data_details.value)
                break
            case "impact_two":
                columns_data[16].push(data_details.value)
                break
            case "impact_three":
                columns_data[17].push(data_details.value)
                break
            case "impact_four":
                columns_data[18].push(data_details.value)
                break
            case "impact_five":
                columns_data[19].push(data_details.value)
                break
            case "impact_six":
                columns_data[20].push(data_details.value)
                break
            case "registered_by": 
                columns_data[21].push(data_details.value)
                break                
        }
    })
    let final = ""
    columns_data.forEach(data => {
        if (data[1] !== undefined) {
            final += data[0] + " " + data[1] + " \n"
        }
        else {
            final += data[0] + " \n"
        }
    })
    return final;
}

const convertYesNoMaybe = (value, intl) => {
    let ret
    switch (value) {
        case -1:
        case "-1":
            ret = "-"
            break
        case 0:
        case "0":
            ret = intl.formatMessage({id:"monitoring.switch.label.no"})
            break
        case 1:
        case "1":
            ret = intl.formatMessage({id:"monitoring.switch.label.yes"})
            break
    }
    return (ret)
}


const convertAlimentation = (dataToExport, intl) => {
    let data = JSON.parse(dataToExport)
    let columns_data = [
        [intl.formatMessage({id:"alimentation.form.transit.title"})],
        [intl.formatMessage({id:"alimentation.form.display.farts"})],
        [intl.formatMessage({id:"alimentation.form.display.bowel_movement"})],
        [intl.formatMessage({id:"alimentation.form.display.nausea"})],
        [intl.formatMessage({id:"alimentation.form.pain.title"})],
        [intl.formatMessage({id:"alimentation.form.display.pain_treatment_efficiency"})],
        [intl.formatMessage({id:"alimentation.form.display.pain_treatment_help"})],
        [intl.formatMessage({id:"alimentation.form.alimentation.title"})],
        [intl.formatMessage({id:"alimentation.form.display.alimentation_water"})],
        [intl.formatMessage({id:"alimentation.form.display.alimentation_yogurt"})],
        [intl.formatMessage({id:"alimentation.form.display.alimentation_light"})],
        [intl.formatMessage({id:"alimentation.form.display.alimentation_almost_normal"})],
        [intl.formatMessage({id:"alimentation.form.display.alimentation_increase"})],
        [intl.formatMessage({id:"alimentation.form.display.alimentation_help"})],
        [intl.formatMessage({id:"form.registered_by"})],                
    ]

    data.forEach(data_details => {
        switch (data_details.label) {
            case "transit_one":
                columns_data[1].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "transit_two":
                columns_data[2].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "transit_three":
                columns_data[3].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "pain_one":
                columns_data[5].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "pain_two":
                columns_data[6].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "alimentation_one":
                columns_data[8].push(convertYesNoMaybe(data_details.value[0], intl))
                columns_data[9].push(convertYesNoMaybe(data_details.value[1], intl))
                columns_data[10].push(convertYesNoMaybe(data_details.value[2], intl))
                columns_data[11].push(convertYesNoMaybe(data_details.value[3], intl))
                break
            case "alimentation_two":
                columns_data[12].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "alimentation_three":
                columns_data[13].push(convertYesNoMaybe(data_details.value, intl))
                break
            case "registered_by": 
                columns_data[14].push(data_details.value)
                break                   
        }
    })

    let final = ""
    columns_data.forEach(data => {
        if (data[1] !== undefined) {
            final += data[0] + " " + data[1] + " \n"
        }
        else {
            final += data[0] + " \n"
        }
    })
    return final;
}

const convertBreathingOxygenRate = (dataToExport) => {
    let ret = ""
    let parsed_values = [...(dataToExport)]
    parsed_values.forEach(v => {
        if (v.label === "respiratory_rate") {
            ret = v.value
        }
    })
    return (ret)
}

const convertBreathingLeakage = (dataToExport) => {
    let ret = ""
    let parsed_values = [...(dataToExport)]
    parsed_values.forEach(v => {
        if (v.label === "respiratory_leak") {
            ret = v.value
        }
    })
    return (ret)
}

const fillWorksheetAlerts = (sheet, patient_data) => {
    if (patient_data.alerts_triggered !== undefined && patient_data.alerts_triggered.length > 0) {
        let fever_alerts = ["Fever alert"]
        let PR_alerts = ["Pulse rate alert"]
        let SPO2_alerts = ["SPO2 alert"]
        let bloodpressure_PR_alerts = ["Tensiometer pulse rate alert"]
        let bloodpressure_sys_alerts = ["Systolic blood pressure alert"]
        let bloodpressure_dia_alerts = ["Diastolic blood pressure alert"]
        let eq5d_alerts = ["EQ5D alert"]
        let eq5d_scale_alerts = ["EQ5D healthscale alert"]
        let mdasi_alerts = ["MDASI alert"]
        let pain_alerts = ["Pain alert"]
        let breathing_rate_alerts = ["Breathing rate alert"]
        let breathing_oxygen_rate_alerts = ["Oxigen rate alert"]
        let breathing_leakage_alerts = ["Leakage alert"]
        let options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        };
        patient_data.alerts_triggered.forEach(oa => {
            let first_sent = new Date(oa.sent)
            let last_sent = new Date(oa.last_sent)
            let acknowledge = new Date(oa.received) 
            let new_al = "1er message: " + first_sent.toLocaleTimeString() + "; Dernier message: " + last_sent.toLocaleTimeString() + "; Validation: " + acknowledge.toLocaleTimeString()+''                       

            switch (oa.note[0]) {
                case "fever_alert" :
                    fever_alerts.push(new_al)
                    break
                case "PR_alert" :
                    PR_alerts.push(new_al)
                    break
                case "SPO2_alert" :
                    SPO2_alerts.push(new_al)
                    break
                case "bloodpressure_PR_alert" :
                    bloodpressure_PR_alerts.push(new_al)
                    break
                case "bloodpressure_sys_high_alert" :
                    bloodpressure_sys_alerts.push(new_al)
                    break
                case "bloodpressure_dia_alert" :
                    bloodpressure_dia_alerts.push(new_al)
                    break
                case "eq5d_alert" :
                    eq5d_alerts.push(new_al)
                    break
                case "eq5d_scale_alert" :
                    eq5d_scale_alerts.push(new_al)
                    break
                case "mdasi_alert" :
                    mdasi_alerts.push(new_al)
                    break
                case "pain_alert" :
                    pain_alerts.push(new_al)
                    break
                case "breathing_rate_alert" :
                    breathing_rate_alerts.push(new_al)
                    break
                case "breathing_oxygen_rate_alert" :
                    breathing_oxygen_rate_alerts.push(new_al)
                    break
                case "breathing_leakage_alert" :
                    breathing_leakage_alerts.push(new_al)
                    break
            }
        })
        if (fever_alerts.length > 1) {
        sheet.getColumn('temperature_alerts').values = fever_alerts;
        }
        if (PR_alerts.length > 1) {
        sheet.getColumn('PR_alerts').values = PR_alerts;
        }
        if (SPO2_alerts.length > 1) {
        sheet.getColumn('SPO2_alerts').values = SPO2_alerts;
        }
        if (bloodpressure_PR_alerts.length > 1) {
        sheet.getColumn('bloodpressure_PR_alerts').values = bloodpressure_PR_alerts;
        }
        if (bloodpressure_sys_alerts.length > 1) {
        sheet.getColumn('bloodpressure_sys_high_alerts').values = bloodpressure_sys_alerts;
        }
        if (bloodpressure_dia_alerts.length > 1) {
        sheet.getColumn('bloodpressure_dia_alerts').values = bloodpressure_dia_alerts;
        }
        if (eq5d_alerts.length > 1) {
        sheet.getColumn('healthForm_alerts').values = eq5d_alerts;
        }
        if (eq5d_scale_alerts.length > 1) {
        sheet.getColumn('healthScale_alerts').values = eq5d_scale_alerts;
        }
        if (mdasi_alerts.length > 1) {
        sheet.getColumn('mdasi_alerts').values = mdasi_alerts;
        }
        if (pain_alerts.length > 1) {
        sheet.getColumn('pain_alerts').values = pain_alerts;
        }
        if (breathing_rate_alerts.length > 1) {
        sheet.getColumn('breathing_rate_alerts').values = breathing_rate_alerts;
        }
        if (breathing_oxygen_rate_alerts.length > 1) {
        sheet.getColumn('breathing_oxygen_rate_alerts').values = breathing_oxygen_rate_alerts;
        }
        if (breathing_leakage_alerts.length > 1) {
        sheet.getColumn('breathing_leakage_alerts').values = breathing_leakage_alerts;
    }
    }
    return sheet
}

const fillWorksheet = (sheet, patient_data, intl, features) => {
    sheet.getColumn('patient_titles').values = generatePatientTitles(patient_data.Patient_Data.INS_Data.NumIdentifiant);

    sheet.getColumn('patient_data').values = patientDataExport(patient_data.Patient_Data);
    if (patient_data.Patient_Data.thermometer !== undefined && patient_data.Patient_Data.thermometer.length !== 0){
        sheet.getColumn('temperature_date').values = getExportFileData(patient_data.Patient_Data.thermometer, "temperature_date");
        sheet.getColumn('temperature_value').values = getExportFileData(patient_data.Patient_Data.thermometer, "temperature");
    }
    if (patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.fever_alert !== undefined && patient_data.Patient_Data.alerts.fever_alert.activated === true) {
        sheet.getColumn('fever_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.fever_alert], "fever_threshold");
        sheet.getColumn('fever_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.fever_alert], "fever_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(features, Utils.featureToBitNumber("niv")))
        && patient_data.Patient_Data.pulseOximeter !== undefined
        && patient_data.Patient_Data.pulseOximeter.pulseRate.length !== 0
        && patient_data.Patient_Data.pulseOximeter.sp02.length !== 0){
        sheet.getColumn('oximeter_date').values = getExportFileData(patient_data.Patient_Data.pulseOximeter.pulseRate, "oximeter_date");
        sheet.getColumn('spo2').values = getExportFileData(patient_data.Patient_Data.pulseOximeter.sp02, "spo2");
        sheet.getColumn('pulse_rate_oxymeter').values = getExportFileData(patient_data.Patient_Data.pulseOximeter.pulseRate, "pulse_rate_oxymeter");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(features, Utils.featureToBitNumber("niv"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.SPO2_alert !== undefined && patient_data.Patient_Data.alerts.SPO2_alert.activated === true) {
        sheet.getColumn('SPO2_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.SPO2_alert], "SPO2_threshold");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(features, Utils.featureToBitNumber("niv"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.PR_alert !== undefined && patient_data.Patient_Data.alerts.PR_alert.activated === true) {
        sheet.getColumn('PR_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.PR_alert], "PR_threshold");
        sheet.getColumn('PR_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.PR_alert], "PR_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("tensiometer")))
        && patient_data.Patient_Data.pulseTensiometer !== undefined 
        && patient_data.Patient_Data.pulseTensiometer.systolic.length !== 0
        && patient_data.Patient_Data.pulseTensiometer.diastolic.length !== 0
        && patient_data.Patient_Data.pulseTensiometer.pulseRate.length !== 0){
        sheet.getColumn('tensiometer_date').values = getExportFileData(patient_data.Patient_Data.pulseTensiometer.diastolic, "tensiometer_date");
        sheet.getColumn('pulse_rate_tensiometer').values = getExportFileData(patient_data.Patient_Data.pulseTensiometer.pulseRate, "pulse_rate_tensiometer");
        sheet.getColumn('systolic').values = getExportFileData(patient_data.Patient_Data.pulseTensiometer.systolic, "systolic");
        sheet.getColumn('diastolic').values = getExportFileData(patient_data.Patient_Data.pulseTensiometer.diastolic, "diastolic");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("tensiometer"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.bloodpressure_PR_alert !== undefined && patient_data.Patient_Data.alerts.bloodpressure_PR_alert.activated === true) {
        sheet.getColumn('bloodpressure_PR_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.bloodpressure_PR_alert], "bloodpressure_PR_threshold");
        sheet.getColumn('bloodpressure_PR_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.bloodpressure_PR_alert], "bloodpressure_PR_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("tensiometer"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.bloodpressure_sys_high_alert !== undefined && patient_data.Patient_Data.alerts.bloodpressure_sys_high_alert.activated === true) {
        sheet.getColumn('bloodpressure_sys_high_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.bloodpressure_sys_high_alert], "bloodpressure_sys_high_threshold");
        sheet.getColumn('bloodpressure_sys_high_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.bloodpressure_sys_high_alert], "bloodpressure_sys_high_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("tensiometer"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.bloodpressure_dia_alert !== undefined && patient_data.Patient_Data.alerts.bloodpressure_dia_alert.activated === true) {
        sheet.getColumn('bloodpressure_dia_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.bloodpressure_dia_alert], "bloodpressure_dia_threshold");
        sheet.getColumn('bloodpressure_dia_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.bloodpressure_dia_alert], "bloodpressure_dia_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("scale"))) && patient_data.Patient_Data.scale_data !== undefined && patient_data.Patient_Data.scale_data.weight.length !== 0){
        sheet.getColumn('weight_date').values = getExportFileData(patient_data.Patient_Data.scale_data.weight, "weight_date");
        sheet.getColumn('weight').values = getExportFileData(patient_data.Patient_Data.scale_data.weight, "weight");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("scale"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.weight_alert !== undefined && patient_data.Patient_Data.alerts.weight_alert.activated === true) {
        sheet.getColumn('weight_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.weight_alert], "weight_threshold");
        sheet.getColumn('weight_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.weight_alert], "weight_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("pain"))) && patient_data.Patient_Data.pain !== undefined && patient_data.Patient_Data.pain.length !== 0){
        sheet.getColumn('pain_date').values = getExportFileData(patient_data.Patient_Data.pain, "pain_date");
        sheet.getColumn('pain').values = getExportFileData(patient_data.Patient_Data.pain, "pain");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("pain"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.pain_alert !== undefined && patient_data.Patient_Data.alerts.pain_alert.activated === true) {
        sheet.getColumn('pain_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.pain_alert], "pain_threshold");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_EQ5D"))) 
        && patient_data.Patient_Data.eq5d !== undefined 
        && patient_data.Patient_Data.eq5d.form_res.length !== 0
        && patient_data.Patient_Data.eq5d.healthscale.length !== 0){
        sheet.getColumn('healthForm_date').values =   getExportFileData(patient_data.Patient_Data.eq5d.form_res, "healthForm_date");
        sheet.getColumn('healthForm').values =        getExportFileData(patient_data.Patient_Data.eq5d.form_res, "healthForm");
        sheet.getColumn('healthScale').values =       getExportFileData(patient_data.Patient_Data.eq5d.healthscale, "healthScale");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_EQ5D"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.eq5d_alert !== undefined && patient_data.Patient_Data.alerts.eq5d_alert.activated === true) {
        sheet.getColumn('healthForm_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.eq5d_alert], "healthForm_threshold");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_EQ5D"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.eq5d_scale_alert !== undefined && patient_data.Patient_Data.alerts.eq5d_scale_alert.activated === true) {
        sheet.getColumn('healthScale_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.eq5d_scale_alert], "healthScale_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_SF36"))) && patient_data.Patient_Data.sf36 !== undefined && patient_data.Patient_Data.sf36.form_res.length !== 0){
        sheet.getColumn('sf36_date').values =   getExportFileData(patient_data.Patient_Data.sf36.form_res, "sf36_date");
        sheet.getColumn('sf36').values =        getExportFileData(patient_data.Patient_Data.sf36.form_res, "sf36", intl);
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_MDASI"))) && patient_data.Patient_Data.mdasi !== undefined && patient_data.Patient_Data.mdasi.form_res.length !== 0){
        sheet.getColumn('mdasi_date').values =   getExportFileData(patient_data.Patient_Data.mdasi.form_res, "mdasi_date");
        sheet.getColumn('mdasi').values =        getExportFileData(patient_data.Patient_Data.mdasi.form_res, "mdasi", intl);
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_MDASI"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.mdasi_alert !== undefined && patient_data.Patient_Data.alerts.mdasi_alert.activated === true) {
        sheet.getColumn('mdasi_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.mdasi_alert], "mdasi_threshold", intl);
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("healthform_ALIMENTATION"))) && patient_data.Patient_Data.alimentation !== undefined && patient_data.Patient_Data.alimentation.form_res.length !== 0){
        sheet.getColumn('alimentation_date').values =   getExportFileData(patient_data.Patient_Data.alimentation.form_res, "alimentation_date");
        sheet.getColumn('alimentation').values =        getExportFileData(patient_data.Patient_Data.alimentation.form_res, "alimentation", intl);
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("niv"))) && patient_data.Patient_Data.breathing !== undefined && patient_data.Patient_Data.breathing.respiratory_rate !== undefined && patient_data.Patient_Data.breathing.respiratory_rate.length !== 0){
        sheet.getColumn('breathing_date').values =          getExportFileData(patient_data.Patient_Data.breathing.respiratory_rate, "breathing_date");
        sheet.getColumn('breathing_rate').values =          getExportFileData(patient_data.Patient_Data.breathing.respiratory_rate, "breathing_rate");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("oxigen_therapy"))) && patient_data.Patient_Data.breathing !== undefined && patient_data.Patient_Data.breathing.oxygen_flow_rate !== undefined && patient_data.Patient_Data.breathing.oxygen_flow_rate.length !== 0){
        sheet.getColumn('oxygen_rate_date').values =          getExportFileData(patient_data.Patient_Data.breathing.oxygen_flow_rate, "oxygen_rate_date");
        sheet.getColumn('oxygen_flow_rate').values =          getExportFileData(patient_data.Patient_Data.breathing.oxygen_flow_rate, "oxygen_flow_rate");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("niv"))) && patient_data.Patient_Data.breathing !== undefined && patient_data.Patient_Data.breathing.respiratory_leak !== undefined && patient_data.Patient_Data.breathing.respiratory_leak.length !== 0){
        sheet.getColumn('breathing_leakage_date').values =          getExportFileData(patient_data.Patient_Data.breathing.respiratory_leak, "breathing_leakage_date");
        sheet.getColumn('breathing_leakage').values =          getExportFileData(patient_data.Patient_Data.breathing.respiratory_leak, "breathing_leakage");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("niv"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.breathing_rate_alert !== undefined && patient_data.Patient_Data.alerts.breathing_rate_alert.activated === true) {
        sheet.getColumn('breathing_rate_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.breathing_rate_alert], "breathing_rate_threshold");
        sheet.getColumn('breathing_rate_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.breathing_rate_alert], "breathing_rate_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("oxigen_therapy"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.breathing_oxygen_rate_alert !== undefined && patient_data.Patient_Data.alerts.breathing_oxygen_rate_alert.activated === true) {
        sheet.getColumn('breathing_oxygen_rate_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.breathing_oxygen_rate_alert], "breathing_oxygen_rate_threshold");
        sheet.getColumn('breathing_oxygen_rate_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.breathing_oxygen_rate_alert], "breathing_oxygen_rate_threshold2");
    }
    if ((Utils.checkBit(features, Utils.featureToBitNumber("niv"))) && patient_data.Patient_Data.alerts !== undefined && patient_data.Patient_Data.alerts.breathing_leakage_alert !== undefined && patient_data.Patient_Data.alerts.breathing_leakage_alert.activated === true) {
        sheet.getColumn('breathing_leakage_threshold').values = getExportFileData([patient_data.Patient_Data.alerts.breathing_leakage_alert], "breathing_leakage_threshold");
        sheet.getColumn('breathing_leakage_threshold2').values = getExportFileData([patient_data.Patient_Data.alerts.breathing_leakage_alert], "breathing_leakage_threshold2");
    }
    sheet = fillWorksheetAlerts(sheet, patient_data.Patient_Data)
    return (sheet);
}

const generateFormatedDate = (to_format) => {
    if (to_format === undefined) {
        return "";
    }
    let temp_date_naissance = new Date(to_format)
    let temp_date_naissance_jour
    let temp_date_naissance_month
    if (parseInt(temp_date_naissance.getDate()) < 10) {
        temp_date_naissance_jour = "0" + (temp_date_naissance.getDate());
    }
    else {
        temp_date_naissance_jour = (temp_date_naissance.getDate());
    }
    if (parseInt(temp_date_naissance.getMonth()) + 1 < 10) {
        temp_date_naissance_month = "0" + (temp_date_naissance.getMonth() + 1);
    }
    else {
        temp_date_naissance_month = (temp_date_naissance.getMonth() + 1);
    }
    let ret = temp_date_naissance_jour + '-' +temp_date_naissance_month + '-' + temp_date_naissance.getFullYear();
    return (ret)
}

// Excel worksheet names hold at most 31 characters, may not contain
// * ? : / \ [ ] nor start/end with a single quote, may not be empty or
// "History", and must be unique. ExcelJS enforces all of it: it TRUNCATES to
// 31 characters and then THROWS on a duplicate or an illegal name — and one
// throw aborts the WHOLE export, not just the offending sheet.
const EXCEL_SHEET_NAME_MAX_LENGTH = 31;

const sanitizeWorksheetName = (name) =>
    String(name === undefined || name === null ? '' : name)
        .replace(/[*?:/\\[\]]/g, ' ')
        .replace(/^'+|'+$/g, '')
        .trim()
        .substring(0, EXCEL_SHEET_NAME_MAX_LENGTH);

// Appending to a name already at the limit is truncated straight back to the
// name that collided: cut the base to make room for the suffix instead.
const worksheetNameWithSuffix = (base, suffix) =>
    base.substring(0, EXCEL_SHEET_NAME_MAX_LENGTH - suffix.length) + suffix;

const worksheetNameTaken = (workbook, name) =>
    workbook.worksheets.some((sheet) => sheet.name.toLowerCase() === name.toLowerCase());

/**
 * A worksheet name ExcelJS accepts for this profile: sanitized, within the
 * 31-character limit and unique in the workbook. Two profiles whose names only
 * differ past the 31st character (INS research profiles do) would otherwise
 * abort the export with "Worksheet name already exists".
 */
const buildWorksheetName = (workbook, patient_data) => {
    const raw = patient_data.Patient_Data.firstname + ' ' + patient_data.Patient_Data.lastname;
    let base = sanitizeWorksheetName(raw);
    if (base === '' || base === 'History') {
        base = 'Profil';
    }
    if (!worksheetNameTaken(workbook, base)) {
        return base;
    }
    // Identify the profile rather than just numbering it, as before.
    const id_patient = String(patient_data.Patient_Data.id_patient || '');
    if (id_patient !== '') {
        const named_by_id = worksheetNameWithSuffix(base, '_' + id_patient.substring(0, 4));
        if (!worksheetNameTaken(workbook, named_by_id)) {
            return named_by_id;
        }
    }
    for (let i = 2; i <= 999; i++) {
        const numbered = worksheetNameWithSuffix(base, '_' + i);
        if (!worksheetNameTaken(workbook, numbered)) {
            return numbered;
        }
    }
    return worksheetNameWithSuffix(base, '_' + String(Date.now()).slice(-6));
};

const generateWorksheet = (workbook, patient_data, intl, features) => {

    let worksheet_name = buildWorksheetName(workbook, patient_data);

    let sheet = workbook.addWorksheet(worksheet_name);
    let data_to_export = patient_data

    data_to_export.Patient_Data.INS_Data.DateNaissance = generateFormatedDate(data_to_export.Patient_Data.INS_Data.DateNaissance);
    data_to_export.Patient_Data.birthdate = generateFormatedDate(data_to_export.Patient_Data.birthdate);

    //Creating and filling the data in the sheet
    sheet.columns = generateColumns(data_to_export, features);
    sheet = fillWorksheet(sheet, data_to_export, intl, features);
    //Adding the datamatrix if needed
    if (data_to_export.Patient_Data.INS_Data.NumIdentifiant){
        let buf = generateDatamatrix(data_to_export);
        var logo = workbook.addImage({
        buffer: buf,
        extension: 'jpeg',
        });
        sheet.getCell('A7').font = { bold: true };
        sheet.addImage(logo, {
            tl: { col: 0, row: 15 },
            ext: { width: 100, height: 100 }
        });
        sheet.getRow(16).alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getColumn(1).width = 22;
        sheet.getRow(16).height = 100;
    }

    return (sheet)
}

// Function to return data
const generateColumns = (dataToExport, features) => {
    let ret = [
        {header: "ID patient", key: "patient_titles", width: 25, font: { bold: true }},
    ]
    ret.push({header: "", key: "patient_data", width: 20, numFmt: 'd/m/yyyy'})
        ret.push({header: "Date", key: "temperature_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
    ret.push({header: "", key: "ins_to_temperature", width: 20})
        ret.push({header: "Temperature", key: "temperature_value", width: 20})
        ret.push({header: "Fever threshold", key: "fever_threshold", width: 20})
        ret.push({header: "Fever threshold 2", key: "fever_threshold2", width: 20})
        ret.push({header: "Temperature alerts", key: "temperature_alerts", width: 70})
        ret.push({header: "", key: "temperature_to_oxymeter", width: 4})
    if (Utils.checkBit(features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(features, Utils.featureToBitNumber("niv"))) {
        ret.push({header: "Date", key: "oximeter_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "SPO2", key: "spo2", width: 20})
        ret.push({header: "SPO2 threshold", key: "SPO2_threshold", width: 20})
        ret.push({header: "SPO2 alerts", key: "SPO2_alerts", width: 70})
        ret.push({header: "Pulse rate", key: "pulse_rate_oxymeter", width: 20})
        ret.push({header: "Pulse rate threshold", key: "PR_threshold", width: 20})
        ret.push({header: "Pulse rate threshold 2", key: "PR_threshold2", width: 20})
        ret.push({header: "Pulse rate alerts", key: "PR_alerts", width: 70})
        ret.push({header: "", key: "oxymeter_to_tensiometer", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("tensiometer"))) {
        ret.push({header: "Date", key: "tensiometer_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "Tensiometer pulse rate", key: "pulse_rate_tensiometer", width: 20})
        ret.push({header: "Tensiometer pulse rate threshold", key: "bloodpressure_PR_threshold", width: 30})
        ret.push({header: "Tensiometer pulse rate threshold 2", key: "bloodpressure_PR_threshold2", width: 35})
        ret.push({header: "Tensiometer pulse rate alerts", key: "bloodpressure_PR_alerts", width: 70})
        ret.push({header: "Systolic", key: "systolic", width: 20})
        ret.push({header: "Systolic threshold", key: "bloodpressure_sys_high_threshold", width: 20})
        ret.push({header: "Systolic threshold 2", key: "bloodpressure_sys_high_threshold2", width: 20})
        ret.push({header: "Systolic alerts", key: "bloodpressure_sys_high_alerts", width: 70})
        ret.push({header: "Diastolic", key: "diastolic", width: 20})
        ret.push({header: "Diastolic threshold", key: "bloodpressure_dia_threshold", width: 20})
        ret.push({header: "Diastolic threshold 2", key: "bloodpressure_dia_threshold2", width: 20})
        ret.push({header: "Diastolic alerts", key: "bloodpressure_dia_alerts", width: 70})
        ret.push({header: "", key: "tensiometer_to_scale", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("scale"))) {
        ret.push({header: "Date", key: "weight_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "Weight", key: "weight", width: 20})
        ret.push({header: "Weight threshold", key: "weight_threshold", width: 20})
        ret.push({header: "Weight threshold 2", key: "weight_threshold2", width: 20})
        ret.push({header: "Weight alerts", key: "weight_alerts", width: 70})
        ret.push({header: "", key: "scale_to_pain", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("pain"))) {
        ret.push({header: "Date", key: "pain_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "Douleur", key: "pain", width: 20})
        ret.push({header: "Pain threshold", key: "pain_threshold", width: 20})
        ret.push({header: "Pain alerts", key: "pain_alerts", width: 70})
        ret.push({header: "", key: "pain_to_healthForm", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("healthform_EQ5D"))) {
        ret.push({header: "Date", key: "healthForm_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "healthForm", key: "healthForm", width: 20})
        ret.push({header: "HealthForm threshold", key: "healthForm_threshold", width: 20})
        ret.push({header: "HealthForm alerts", key: "healthForm_alerts", width: 70})
        ret.push({header: "healthScale", key: "healthScale", width: 20})
        ret.push({header: "HealthScale threshold", key: "healthScale_threshold", width: 20})
        ret.push({header: "HealthScale alerts", key: "healthScale_alerts", width: 70})
        ret.push({header: "", key: "eq5d_to_sf36", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("healthform_SF36"))) {
        ret.push({header: "Date", key: "sf36_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "sf36", key: "sf36", width: 20})
        ret.push({header: "", key: "sf36_to_mdasi", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("healthform_MDASI"))) {
        ret.push({header: "Date", key: "mdasi_date", width: 10, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "mdasi", key: "mdasi", width: 20})
        ret.push({header: "MDASI threshold", key: "mdasi_threshold", width: 20})
        ret.push({header: "MDASI alerts", key: "mdasi_alerts", width: 70})
        ret.push({header: "", key: "mdasi_to_alimentation", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("healthform_ALIMENTATION"))) {
        ret.push({header: "Date", key: "alimentation_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "alimentation", key: "alimentation", width: 20})
        ret.push({header: "", key: "alimentation_to_breathing", width: 4})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("niv"))) {
        ret.push({header: "Date", key: "breathing_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "Breathing rate", key: "breathing_rate", width: 20})
        ret.push({header: "Breathing rate threshold", key: "breathing_rate_threshold", width: 25})
        ret.push({header: "Breathing rate threshold 2", key: "breathing_rate_threshold2", width: 25})
        ret.push({header: "Breathing rate alerts", key: "breathing_rate_alerts", width: 70})
        ret.push({header: "Date", key: "breathing_leakage_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "Breathing leakage", key: "breathing_leakage", width: 20})
        ret.push({header: "Breathing leakage threshold", key: "breathing_leakage_threshold", width: 25})
        ret.push({header: "Breathing leakage threshold 2", key: "breathing_leakage_threshold2", width: 25})
        ret.push({header: "Breathing leakage alerts", key: "breathing_leakage_alerts", width: 70})
    }
    if (Utils.checkBit(features, Utils.featureToBitNumber("oxigen_therapy"))) {
        ret.push({header: "Date", key: "oxygen_rate_date", width: 19, numFmt:'d/m/yyyy\\ h:mm:ss'})
        ret.push({header: "Oxygen rate", key: "oxygen_flow_rate", width: 20})
        ret.push({header: "Oxygen rate threshold", key: "breathing_oxygen_rate_threshold", width: 30})
        ret.push({header: "Oxygen rate threshold 2", key: "breathing_oxygen_rate_threshold2", width: 30})
        ret.push({header: "Oxygen rate alerts", key: "breathing_oxygen_rate_alerts", width: 70})
    }
    return (ret);
}

const generatePatientTitles = (ins_or_not) => {
    let ret = [];
    if (ins_or_not !== undefined && ins_or_not !== null && ins_or_not !== "null" && ins_or_not !== ""){
        ret = ["ID patient", "Firstname","Lastname","Birthdate","Sex","", "INS data","INS number","Birthname","1st birthname","Birthdate","Sex","Used name","Used firstname","INSEE. Birthplace"];
    }
    else {
        ret = ["ID patient", "Firstname","Lastname","Birthdate","Sex"];
    }
    return ret
}

const generateFormatedTextDatamatrix = (data) => {
    let header = "IS010000000000000000000000"
    let content = "S1" + data.Patient_Data.INS_Data.NumIdentifiant + data.Patient_Data.INS_Data.Cle
    if (data.Patient_Data.INS_Data.OID.length < 20) {
        content += "S2" + data.Patient_Data.INS_Data.OID + String.fromCharCode(29);
    }
    else {
        content += "S2" + data.Patient_Data.INS_Data.OID;
    }
    if (data.Patient_Data.INS_Data.PrenomNaissance.length < 100) {
        content += "S3" + data.Patient_Data.INS_Data.PrenomNaissance + String.fromCharCode(29);
    }
    else {
        content += "S3" + data.Patient_Data.INS_Data.PrenomNaissance;
    }
    if (data.Patient_Data.INS_Data.NomNaissance.length < 100) {
        content += "S4" + data.Patient_Data.INS_Data.NomNaissance + String.fromCharCode(29);
    }
    else {
        content += "S3" + data.Patient_Data.INS_Data.NomNaissance;
    }
    content += "S5" + data.Patient_Data.INS_Data.Sex;
    content += "S6" + data.Patient_Data.INS_Data.DateNaissance;
    if (data.Patient_Data.INS_Data.LieuNaissance !== undefined && data.Patient_Data.INS_Data.LieuNaissance !== null && data.Patient_Data.INS_Data.LieuNaissance !== "") {
        content += "S7" + data.Patient_Data.INS_Data.LieuNaissance
    }
    let ret = header + content;
    //let ret = "azertyuiopqsdfghjklmwxcvbnazertyuiopqsdfghjklmwxcvbnazertyuiopqsdfghjklm"
    return (ret)
}

const generateDatamatrix = (ins_data) => {
    let canvas = document.createElement("canvas");
    bwipjs.toCanvas(canvas, {
      bcid: "datamatrix", // Barcode type
      text: generateFormatedTextDatamatrix(ins_data), // Text to encode
      scale: 10, // 3x scaling factor
      height: 10, // Bar height, in millimeters
      includetext: true, // Show human-readable text,
      padding: "10",
      textxalign: "center" // Always good to set this
    });
    const ctx = canvas.getContext("2d");

    ctx.font = "110px Arial";
    ctx.fillText("INS à scanner",100,450);

    let str = canvas.toDataURL()
    let data = str.replace(/^data:image\/\w+;base64,/, "");
    let buf = Buffer.from(data, "base64");
    return (buf);
}

// Function to return patient data
const patientDataExport = (patient_data) => {
    let ret = [""]
    if (patient_data.INS_Data.NomNaissance !== undefined) {
        ret[1] = patient_data.INS_Data.NomNaissance;
    }
    else {
        ret[1] = patient_data.lastname;
    }
    if (patient_data.INS_Data.PrenomNaissance !== undefined) {
        ret[2] = patient_data.INS_Data.PrenomNaissance;
    }
    else {
        ret[2] = patient_data.firstname;
    }
    if (patient_data.INS_Data.DateNaissance !== undefined && patient_data.INS_Data.DateNaissance !== null && patient_data.INS_Data.DateNaissance !== "") {
        ret[3] = patient_data.INS_Data.DateNaissance;
    }
    else {
        ret[3] = patient_data.birthdate;
    }
    if (patient_data.INS_Data.Sex !== undefined && patient_data.INS_Data.Sex !== null && patient_data.INS_Data.Sex !== "") {
        ret[4] = patient_data.INS_Data.Sex;
    }
    else {
        ret[4] = patient_data.gender;
    }
    ret[5] = "";
    ret[6] = "";
    //INS patient_data
    if (patient_data.INS_Data.NumIdentifiant !== undefined && patient_data.INS_Data.NumIdentifiant !== null && patient_data.INS_Data.NumIdentifiant !== "") {
        ret[7] = patient_data.INS_Data.NumIdentifiant + patient_data.INS_Data.Cle;
        if (patient_data.INS_Data.OID === "1.2.250.1.213.1.4.8"){
            ret[7] += " (NIR)";
        }
        else {
            ret[7] += " (NIA)";
        }
    }
    else {
        ret[7] = ""
    }
    if (patient_data.INS_Data.NomNaissance !== undefined && patient_data.INS_Data.NomNaissance !== null && patient_data.INS_Data.NomNaissance !== "") {
        ret[8] = patient_data.INS_Data.NomNaissance;
    }
    else {
        ret[8] = ""
    }
    if (patient_data.INS_Data.PremierPrenom !== undefined && patient_data.INS_Data.PremierPrenom !== null && patient_data.INS_Data.PremierPrenom !== "") {
        ret[9] = patient_data.INS_Data.PremierPrenom;
    }
    else {
        ret[9] = ""
    }
    if (patient_data.INS_Data.DateNaissance !== undefined && patient_data.INS_Data.DateNaissance !== null && patient_data.INS_Data.DateNaissance !== "") {
        ret[10] = patient_data.INS_Data.DateNaissance;
    }
    else {
        ret[10] = ""
    }
    if (patient_data.INS_Data.Sex !== undefined && patient_data.INS_Data.Sex !== null && patient_data.INS_Data.Sex !== "") {
        ret[11] = patient_data.INS_Data.Sex;
    }
    else {
        ret[11] = ""
    }
    if (patient_data.INS_Data.NomUtilise !== undefined && patient_data.INS_Data.NomUtilise !== null && patient_data.INS_Data.NomUtilise !== "") {
        ret[12] = patient_data.INS_Data.NomUtilise;
    }
    else {
        ret[12] = patient_data.INS_Data.NomNaissance
    }
    if (patient_data.INS_Data.PrenomUtilise !== undefined && patient_data.INS_Data.PrenomUtilise !== null && patient_data.INS_Data.PrenomUtilise !== "") {
        ret[13] = patient_data.INS_Data.PrenomUtilise;
    }
    else {
        ret[13] = patient_data.INS_Data.PrenomNaissance
    }
    if (patient_data.INS_Data.LieuNaissance !== undefined && patient_data.INS_Data.LieuNaissance !== null && patient_data.INS_Data.LieuNaissance !== "") {
        ret[14] = patient_data.INS_Data.LieuNaissance;
    }
    else {
        ret[14] = ""
    }

    return(ret)
}

// Function to return data
const getExportFileData = (dataToExportOrigin, title, intl) => {

    let data = ["Date"];
    let dataToExport
    if (dataToExportOrigin !== undefined) {
        dataToExport = [...dataToExportOrigin.slice()]
    }
    else {
        dataToExport = []
    }
    let i = 0
    let date_options =  {year: 'numeric', month: 'numeric', day: 'numeric'}
    switch (title) {
        case "temperature" :
            data = ["Temperature"]
            break
        case "fever_threshold" :
            data = ["Fever threshold"]
            break
        case "fever_threshold2" :
            data = ["Fever threshold 2"]
            break
        case "spo2" :
            data = ["SPO2"]
            break
        case "SPO2_threshold" :
            data = ["SPO2 threshold"]
            break
        case "pulse_rate_oxymeter" :
            data = ["Pulse rate"]
            break
        case "PR_threshold" :
            data = ["Pulse rate threshold"]
            break
        case "PR_threshold2" :
            data = ["Pulse rate threshold 2"]
            break
        case "pulse_rate_tensiometer" :
            data = ["Tensiometer pulse rate"]
            break
        case "bloodpressure_PR_threshold" :
            data = ["Tensiometer pulse rate threshold"]
            break
        case "bloodpressure_PR_threshold2" :
            data = ["Tensiometer pulse rate threshold 2"]
            break
        case "systolic" :
            data = ["Systolic"]
            break
        case "bloodpressure_sys_high_threshold" :
            data = ["Systolic threshold"]
            break
        case "bloodpressure_sys_high_threshold2" :
            data = ["Systolic threshold 2"]
            break
        case "diastolic" :
            data = ["Diastolic"]
            break
        case "bloodpressure_dia_threshold" :
            data = ["Diastolic threshold"]
            break
        case "bloodpressure_dia_threshold2" :
            data = ["Diastolic threshold 2"]
            break
        case "weight" :
            data = ["Weight"]
            break
        case "weight_threshold" :
            data = ["Weight threshold"]
            break
        case "weight_threshold2" :
            data = ["Weight threshold 2"]
            break
        case "pain" :
            data = ["Pain"]
            break
        case "pain_threshold" :
            data = ["Pain threshold"]
            break
        case "healthForm" :
            data = ["HealthForm"]
            break
        case "healthForm_threshold" :
            data = ["EQ5D threshold"]
            break
        case "healthScale" :
            data = ["HealthScale"]
            break
        case "healthScale_threshold" :
            data = ["Healthscale threshold"]
            break
        case "sf36" :
            data = ["SF36"]
            break
        case "mdasi" :
            data = ["MDASI"]
            break
        case "mdasi_threshold" :
            data = ["MDASI threshold"]
            break
        case "alimentation" :
            data = ["Alimentation"]
            break
        case "breathing_rate":
            data = ["Breathing rate"]
            break
        case "breathing_rate_threshold":
            data = ["Breathing rate threshold"]
            break
        case "breathing_rate_threshold2":
            data = ["Breathing rate threshold 2"]
            break
        case "oxygen_flow_rate":
            data = ["Breathing oxygen rate"]
            break
        case "breathing_oxygen_rate_threshold":
            data = ["Breathing oxygen rate threshold"]
            break
        case "breathing_oxygen_rate_threshold2":
            data = ["Breathing oxygen rate threshold 2"]
            break
        case "breathing_leakage":
            data = ["Breathing leakage"]
            break
        case "breathing_leakage_threshold":
            data = ["Breathing leakage threshold"]
            break
        case "breathing_leakage_threshold2":
            data = ["Breathing leakage threshold 2"]
            break
    }     

    if(dataToExport !== undefined){
        while (i < dataToExport.length) {
            if (title.includes("date")) {
                let this_date = new Date(dataToExport[i].x)
                data[i+1] = this_date.toLocaleDateString(undefined, date_options) + " " + this_date.toTimeString().slice(0, 8);
            }
            else if (title.split('_')[title.split('_').length - 1] === "threshold") {
                data[i+1] = dataToExport[i].threshold
            }
            else if (title.split('_')[title.split('_').length - 1] === "threshold2") {
                if (dataToExport[i].threshold2 === null || dataToExport[i].threshold2 === undefined) {
                    data[i+1] = "undefined"
                }
                else {
                    data[i+1] = dataToExport[i].threshold2
                }
            }
            else {
                switch (title) {
                    case "eq5d":
                        data[i+1] = dataToExport[i].y;
                        break
                    case "sf36":
                        data[i+1] = convertSF36(dataToExport[i].y, intl)
                        break
                    case "mdasi":
                        data[i+1] = convertMDASI(dataToExport[i].y, intl)
                        break
                    case "alimentation":
                        data[i+1] = convertAlimentation(dataToExport[i].y, intl)
                        break
                    default:
                data[i+1] = dataToExport[i].y;
                        break
                }
            }
            i++;
        }
    }
    return (data);
}

// Function to return filename
const getExportFileName = (dates) => {

    let filename = "";

    //Set document title
    if(dates !== undefined){
        if(dates.length === 1){
            filename = "Tucky_Center_Export_" + dates[0] + ".xlsx";
        }
        else if(dates.length === 2){
            filename = "Tucky_Center_Export_" + dates[0] + "_" + dates[1] +".xlsx";
        }
        else{
            filename = "Tucky_Center_Export";
        }
    }
    return (filename);

}

// Named export so the worksheet-naming rules can be unit tested against a
// real ExcelJS workbook without rendering a profile.
export { buildWorksheetName };

//Export functions to make them visible and usable in other files
const ExportFile = {
    generateWorksheet,
    getExportFileName
};

export default injectIntl(ExportFile);